import { createStore } from 'vuex'

let webSocket

const connect = () => {
  webSocket = new WebSocket('wss://tv.jerzyzieba.com/api/pubsub')
  webSocket.onopen = function() {
    if (store.state.videos.length > 0) {
      return
    }
    store.dispatch('getVideos', { service: 'facebook', page: 1 })
  }
  webSocket.onmessage = function (event) {
    const data = JSON.parse(event.data)
    store.commit(data.type, data)
  }
  webSocket.onclose = function() {
    setTimeout(() => {
      connect()
    }, 5000)
  }
}

const store = createStore({
  state: {
    status: [],
    videoPages: 0,
    videos: [],
    video: null
  },
  mutations: {
    ping () {
      webSocket.send(JSON.stringify({ type: 'pong' }))
    },
    status (state, { data }) {
      state.status = data
    },
    videos (state, { pages, data }) {
      state.videoPages = pages
      state.videos = data
    },
    video (state, { video }) {
      state.video = video
    }
  },
  actions: {
    getVideos (context, { service, page }) {
      webSocket.send(JSON.stringify({ type: 'videos', service: service, page: page }))
    },
    playVideo ({ commit }, { video }) {
      commit('video', { video })
    }
  },
  modules: {
  }
})

connect()

export default store
